export class SaveOutsideSurveyMainAddressDto {
  surveyId: string;
  buildingId: string;
  addressId: string;

  constructor(surveyId: string, buildingId: string, addressId: string) {
    this.surveyId = surveyId;
    this.buildingId = buildingId;
    this.addressId = addressId;
  }
}
